<div class="table-responsive">
    <div class="flex-container">
        <h4>{{ '@vehicleScheduleDetail' | translate }}: {{vehicleSchedule?.vin}} </h4>
    </div>
    <div *ngIf="loading" class="loading-strip">
        <mat-spinner [diameter]="40"></mat-spinner>
    </div>
    <mat-tab-group animationDuration="100ms" [selectedIndex]="selectedIndex" (selectedTabChange)="onTabClick($event)"
        *ngIf="!loading">
        <mat-tab label="{{ '@summary' | translate }}">
            <div class="content" *ngIf="vehicleSchedule">
                <mat-card appearance="outlined">
                    <mat-card-content>
                        <div class="flex-wrap">
                            <div class="flex-100">
                                <mat-card appearance="outlined">
                                    <mat-card-content>
                                        <mat-slide-toggle class="activate" checked="{{vehicleSchedule.isActive}}" color="primary" disabled>
                                            {{ '@activate' | translate}}
                                        </mat-slide-toggle>
                                        <mat-form-field class="padded-input half-sized">
                                            <mat-label>{{ '@name' | translate }}</mat-label>
                                            <input matInput value="{{vehicleSchedule.schedule.name}}" class="text-black" disabled>
                                        </mat-form-field>
                                        <mat-form-field class="padded-input">
                                            <mat-label>{{ '@category' | translate }}</mat-label>
                                            <input matInput value="{{vehicleSchedule.schedule.category}}" class="text-black" disabled>
                                        </mat-form-field>
                                        <mat-form-field class="padded-input">
                                            <mat-label>{{ '@action' | translate }}</mat-label>
                                            <mat-select placeholder="Select Action" [(value)]="vehicleSchedule.schedule.action" disabled>
                                                <mat-option *ngFor="let name of Actions | enumToArray" [value]="Actions[name]">
                                                    {{name}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-form-field class="padded-input full-sized">
                                            <mat-label>{{ '@description' | translate }}</mat-label>
                                            <input matInput value="{{vehicleSchedule.schedule.description}}" class="text-black" disabled>
                                        </mat-form-field>
                                        <mat-form-field class="padded-input">
                                            <mat-label>{{ '@expectedHours' | translate }}</mat-label>
                                            <input matInput value="{{vehicleSchedule.expectedHours}}" class="text-black" disabled>
                                        </mat-form-field>
                                        <mat-form-field class="padded-input">
                                            <mat-label>{{ '@schedule' | translate }}</mat-label>
                                            <mat-select placeholder="Select Schedule" [(value)]="vehicleSchedule.fleetScheduleId" disabled>
                                                <mat-option *ngFor="let fleetSchedule of fleetSchedules" [value]="fleetSchedule.id">
                                                    {{fleetSchedule.name}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-form-field class="padded-input">
                                            <mat-label>{{ '@sensorType' | translate }}</mat-label>
                                            <input matInput value="{{sensorType}}" class="text-black" disabled>
                                        </mat-form-field>

                                        <div class="cfr" *ngIf="vehicleSchedule.schedule.cfrSections?.length > 0">
                                            <mat-label>{{ '@cfrSection' | translate }}</mat-label>
                                            <mat-chip-listbox>
                                                <mat-chip-option *ngFor="let section of vehicleSchedule.schedule.cfrSections" (click)="openCFR(section)">
                                                    {{ section }}
                                                </mat-chip-option>
                                            </mat-chip-listbox>
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                            <div class="flex-50">
                                <mat-card appearance="outlined">
                                    <mat-card-content>
                                        <table class="table">
                                            <tr>
                                                <th>{{ '@manufacturer' | translate }}</th>
                                                <th>{{ '@model' | translate }}</th>
                                                <th>{{ '@type' | translate }}</th>
                                                <th>{{ '@startYear' | translate }}</th>
                                                <th>{{ '@endYear' | translate }}</th>
                                            </tr>
                                            <tr *ngFor="let group of vehicleSchedule.schedule.groups">
                                                <td>{{group.manufacturer}}</td>
                                                <td>{{group.model}}</td>
                                                <td>{{group.other}}</td>
                                                <td>{{group.startYear}}</td>
                                                <td>{{group.endYear}}</td>
                                            </tr>
                                        </table>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                            <div class="flex-50">
                                <mat-card appearance="outlined">
                                    <mat-card-content>
                                        <table class="table">
                                            <tr>
                                                <th>{{ '@usage' | translate }}</th>
                                                <th>{{ '@interval' | translate }}</th>
                                            </tr>
                                            <tr *ngFor="let criteria of vehicleSchedule.currentCriteria">
                                                <td>
                                                    <span *ngFor="let attributes of criteria.schedulingAttributes | keyvalue">
                                                        {{attributes.key}}/
                                                        {{attributes.value}}
                                                        <br />
                                                    </span>
                                                </td>
                                                <td>{{criteria | scheduleCriteria}}</td>
                                            </tr>
                                        </table>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                            <div class="flex-25" *ngIf="vehicleSchedule.lastMaintenance">
                                <mat-card appearance="outlined">
                                    <mat-card-content>
                                        <img *ngIf="vehicleSchedule.lastMaintenance.vehicleState.dashboard.AmberWarningLamp" title="{{'@checkEngineOn' | translate}}" src="{{assetUrl}}/mil_enabled.png" style="width: 13.75%" />
                                        <img *ngIf="!vehicleSchedule.lastMaintenance.vehicleState.dashboard.AmberWarningLamp" title="{{'@checkEngineOff' | translate}}" src="{{assetUrl}}/mil_disabled.png" style="width: 13.75%" /> &nbsp;&nbsp;
                                        <img *ngIf="vehicleSchedule.lastMaintenance.vehicleState.dashboard.MalfunctionLamp" title="{{'@malfunctionOn' | translate}}" src="{{assetUrl}}/awl_enabled.png" style="width: 13.75%" />
                                        <img *ngIf="!vehicleSchedule.lastMaintenance.vehicleState.dashboard.MalfunctionLamp" title="{{'@malfunctionOff' | translate}}" src="{{assetUrl}}/awl_disabled.png" style="width: 13.75%" />&nbsp;&nbsp;
                                        <img *ngIf="vehicleSchedule.lastMaintenance.vehicleState.dashboard.ProtectWarningLamp" title="{{'@protectEngineOn' | translate}}" src="{{assetUrl}}/protect_enabled.png" style="width: 13.75%" />
                                        <img *ngIf="!vehicleSchedule.lastMaintenance.vehicleState.dashboard.ProtectWarningLamp" title="{{'@protectEngineOff' | translate}}" src="{{assetUrl}}/protect_disabled.png" style="width: 13.75%" />&nbsp;&nbsp;
                                        <img *ngIf="vehicleSchedule.lastMaintenance.vehicleState.dashboard.RedStopLamp" title="{{'@stopEngineOn' | translate}}" src="{{assetUrl}}/stop_enabled.png" style="width: 13.75%" />
                                        <img *ngIf="!vehicleSchedule.lastMaintenance.vehicleState.dashboard.RedStopLamp" title="{{'@stopEngineOff' | translate}}" src="{{assetUrl}}/stop_disabled.png" style="width: 13.75%" />
                                        <form>
                                            <mat-form-field class="padded-input">
                                                <mat-label>{{ '@odometer' | translate }} </mat-label>
                                                <input matInput value="{{displayOdometer | number }}" disabled class="text-black">
                                            </mat-form-field>
                                            <mat-form-field class="padded-input" *ngIf="vehicleSchedule.lastMaintenance.vehicleState.engine">
                                                <mat-label>{{ '@engineHours' | translate }}</mat-label>
                                                <input matInput value="{{displayOperationDuration | number}}" disabled class="text-black">
                                            </mat-form-field>
                                        </form>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                            <div class="flex-75">
                                <mat-card appearance="outlined">
                                    <mat-card-content>
                                        <mat-form-field class="padded-input">
                                            <mat-label>{{ '@updatedBy' | translate }}</mat-label>
                                            <input matInput value="{{vehicleSchedule.lastMaintenance.updatedBy}}" disabled class="text-black">
                                        </mat-form-field>
                                        <mat-form-field class="padded-input">
                                            <mat-label>{{ '@chooseDate' | translate }}</mat-label>
                                            <input matInput [matDatepicker]="picker" [(ngModel)]="completedDate" disabled class="text-black">
                                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                        </mat-form-field>
                                        <mat-form-field appearance="fill">
                                            <mat-label>{{ '@dateType' | translate }}</mat-label>
                                            <select matNativeControl required [(ngModel)]="selected" name="selectedDateType" disabled class="text-black">
                                                <option value="updateDate">{{'@updateDate' | translate}}</option>
                                                <option value="completeDate">{{'@completeDate' | translate}}</option>
                                            </select>
                                        </mat-form-field>
                                        <mat-form-field class="padded-input full-sized">
                                            <mat-label>{{ '@notes' | translate }}</mat-label>
                                            <textarea matInput value="{{vehicleSchedule.lastMaintenance.notes}}" rows="5" disabled class="text-black"></textarea>
                                        </mat-form-field>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </mat-tab>
        <mat-tab label="{{'@parts' | translate}}">
            <div class="content">
                <mat-card appearance="outlined">
                    <mat-card-content>
                        <div class="flex-wrap">
                            <div class="full-sized" *ngIf="vehicleSchedule">
                                <as-split direction="{{direction}}">
                                    <as-split-area [size]="50">
                                        <div>
                                            <app-part-table-avail [tenantId]="tenantId" [loading]="availLoading" (addData)="addPart($event)" (refreshData)="updateData($event)" [pagedResponse]="partsData">
                                            </app-part-table-avail>
                                        </div>
                                    </as-split-area>
                                    <as-split-area [size]="50">
                                        <div>
                                            <app-part-table-add altTitle="Assigned Parts" (deleteCallBack)="removeParts($event)" [tenantId]="tenantId" [parts]="vehicleSchedule.schedule.parts">
                                            </app-part-table-add>
                                        </div>
                                    </as-split-area>
                                </as-split>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>
